import React, { useEffect } from 'react';
import { sendGenericWebViewAction } from '../../utils';

const SsoCallback: React.FC = () => {
    useEffect(() => {
        const params = new URLSearchParams(window.location.search);
        const authCode = params.get('auth_code') ?? undefined;
        const success = params.get('success') === 'true';
        const reason = params.get('reason') ?? undefined;

        sendGenericWebViewAction('SSO_LOGIN_CALLBACK', { auth_code: authCode, success, reason });
    }, []);

    return null;
};

export default SsoCallback;
